<!-- 竞赛中心 -->
<template>
  <div class="el-ContestList">
    <el-row class="content_block mb20">
      <TitleInfo title="竞赛中心" :titleImg="jingsai"></TitleInfo>
      <el-row style="margin: 20px 20px 0 20px;">
        <span class="title_name">
          <i class="el-icon-s-operation"></i>大赛类型：
        </span>
        <el-tabs class="tabs_class" v-model="signType" @tab-click="handleType">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="证券模拟交易大赛" name="2"></el-tab-pane>
          <el-tab-pane label="金融大数据大赛" name="1"></el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row style="margin: 0 20px;">
        <span class="title_name">
          <i class="el-icon-user"></i>大赛形式：
        </span>
        <el-tabs class="tabs_class" v-model="competitionType" @tab-click="handleForm">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="个人赛" name="1"></el-tab-pane>
          <el-tab-pane label="团队赛" name="2"></el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row style="margin: 0 20px;">
        <span class="title_name">
          <i class="el-icon-menu"></i>大赛状态：
        </span>
        <el-tabs class="tabs_class" v-model="competitionDetailedStatuses" @tab-click="handleState">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="未开始" name="1"></el-tab-pane>
          <el-tab-pane label="报名中" name="2"></el-tab-pane>
          <el-tab-pane label="比赛中" name="3,4,5,6,7,8,9,10"></el-tab-pane>
          <el-tab-pane label="已结束" name="11"></el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row class="list_info">
        <ul>
          <template v-for="(item, index) in courseList">
            <li :key="index">
              <el-row style="position: relative;">
                <el-image class="course_img" :src="$isHttp(item.competitionLogo)"></el-image>
                <p class="limit_line_one tl fontB font14 ml10 mr10 c_p" style="height: 20px;">{{item.competitionName}}</p>
                <p class="_info">比赛时间：<el-image class="_img" :src="time_b"></el-image>{{item.competitionContestStartTime}}</p>
                <p class="_info"><span>&nbsp;</span><el-image class="_img" :src="time_e"></el-image>{{item.competitionContestEndTime}}</p>
                <p class="_info">报名时间：<el-image class="_img" :src="time_b"></el-image>{{item.competitionEnrollStartTime}}</p>
                <p class="_info"><span>&nbsp;</span><el-image class="_img" :src="time_e"></el-image>{{item.competitionEnrollEndTime}}</p>
                <p class="limit_line_one _info mb15">主办方：{{item.competitionTechnicalName}}</p>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
      <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[6, 12, 20, 40]"
          :page-size="limit"
          background
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-empty v-if='courseList.length <= 0' description="暂无数据"></el-empty>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
export default {
  name: "ContestList",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      jingsai:require("../../images/jingsai@2x.png"),
      time_e:require("../../images/time_e@2x.png"),
      time_b:require("../../images/time_b@2x.png"),
      courseList:[],
      signType:"all",
      competitionType:"all", //大赛模式(1个人赛 2团队赛)
      competitionDetailedStatuses:"all",
      total: 0,
      limit:6,
      page:1
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleType(tab, event){ //选择大赛类型
      console.log(tab, event);
      this.getInfo();
    },
    handleForm(tab, event){ //选择大赛形式
      console.log(tab, event);
      this.getInfo();
    },
    handleState(tab, event){ //选择大赛状态
      console.log(tab, event);
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        competitionStatus:1,
        competitionType:this.competitionType == "all"?"":this.competitionType,
        sign:this.signType == "all"?"":this.signType,
        competitionDetailedStatuses:this.competitionDetailedStatuses == "all"?"":this.competitionDetailedStatuses,
      }
      this.$post("/api/competition/getList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.courseList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    courseInon(){
      this.$router.push({name:'CourseHome',query:{courseId:1}});
    }
  }
};
</script>
 <style  lang="less">
  .el-ContestList{
    padding: 20px 20px 0;
    .list_info{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
        padding: 10px;
      }
      li{
        float: left;
        width: calc(20% - 22px);
        min-height: 350px;
        max-width: 350px;
        margin: 10px;
        font-size: 13px;
        border: 1px solid #E1E1E1;
        ._info{
          margin: 0;
          padding: 5px 10px;
          span{
            color: white;
            float: left;
            width: 65px;
          }
        }
      }
    }
    .content_block{
      background-color: #ffffff;
      .title_name{
        font-size: 14px;float: left;line-height: 40px;margin-right:10px;width: 95px;
        i{
          color: #2789E2;font-size: 15px;margin-right: 5px;
        }
      }
      .tabs_class{
        margin-right: 20px;width: calc(100% - 95px);
      }
      .el-tabs__header{
        margin: 0;
      }
    }
    .course_img{
      width: 100%;
      height: 178px;
    }
    ._img{
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
    .el-tabs__nav-wrap::after{
      background-color:white;
    }
    .el-tabs__item{
      padding: 0 15px;
    }
    @media screen and (min-width:2000px){
      li{
        width: calc(20% - 24px);
      }
    }

  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/contest/ContestList.vue